import React, { useRef } from "react";
import cn from "helpers/classnames";
import GroupPlanCard from "./GroupPlanCard";
import TestimonialSection from "./TestimonialSection";
import RequestQuoteSection from "./RequestQuoteSection";
import FaqSection from "./FaqSection";

const GetMoreItem = ({ icon, text }) => (
  <div className="tw-flex tw-items-center">
    <i
      className={`md:tw-hidden lc-icon lc-icon-${icon} tw-text-blue lc-icon-xs tw-mr-1.5`}
    />
    <i
      className={`tw-hidden md:tw-block lc-icon lc-icon-${icon} tw-text-blue lc-icon-sm tw-mr-2`}
    />
    <span className="body-1">{text}</span>
  </div>
);

const RequestQuoteButton = ({ scrollToQuote }) => (
  <button
    data-amplitude="requestQuote"
    type="button"
    onClick={scrollToQuote}
    className="btn btn-default btn-lg tw-mt-0 tw-z-10 tw-w-fit tw-mb-6 md:tw-mb-0"
  >
    Request a quote
  </button>
);

const GroupInfoPage = ({ plans = [] }) => {
  const quoteContainerRef = useRef(null);

  const scrollToQuote = () => {
    if (quoteContainerRef.current) {
      quoteContainerRef.current.scrollIntoView({
        behavior: "smooth",
        block: "start"
      });
      // .quote-form is the target class used in RequestQuoteForm.jsx
      const input = quoteContainerRef.current.querySelector(
        ".quote-form, input, textarea"
      );
      if (input) input.focus();
    }
  };

  return (
    <div className="tw-flex-1 tw-flex tw-flex-col tw-items-center">
      <div className="tw-pt-5 tw-pb-10 tw-text-center tw-justify-start tw-font-serif tw-px-[15px] md:tw-px-0">
        <span className="title-3 tw-text-green-shade-40">Save up to 93%</span>
        <span className="title-3 tw-text-gray"> with a group subscription</span>
      </div>
      <div
        className={cn(
          "groups-info-tile-container tw-py-10 tw-justify-center tw-flex-col",
          "tw-px-[15px] md:tw-flex-row md:tw-px-0"
        )}
      >
        <div className="tw-z-10 tw-flex tw-mr-0 tw-flex-col tw-self-center md:tw-items-start md:tw-mr-9">
          <span className="title-4 tw-mb-1 tw-text-center md:tw-text-left md:tw-mb-3">
            Groups get more
          </span>
          <div
            className={cn(
              "tw-flex tw-flex-row tw-flex-wrap tw-gap-x-3 tw-gap-y-1 tw-justify-center tw-max-w-[452px]",
              "md:tw-max-w-full md:tw-flex-col md:tw-gap-[10px]"
            )}
          >
            <GetMoreItem icon="filters" text="Customizable plans" />
            <GetMoreItem icon="money" text="Exclusive discounts" />
            <GetMoreItem icon="related-quote" text="Priority guide requests" />
            <GetMoreItem icon="sparkles" text="Unlimited AI tool uses" />
            <GetMoreItem icon="pdf" text="School-wide PDF sharing" />
            <GetMoreItem icon="star" text="Dedicated customer support" />
            <div className="tw-basis-full tw-flex tw-justify-center md:tw-basis-auto md:tw-mt-2.5 md:tw-justify-start">
              <RequestQuoteButton scrollToQuote={scrollToQuote} />
            </div>
          </div>
        </div>
        <div className="tw-flex tw-justify-center tw-z-10 tw-flex-col tw-gap-4 sm:tw-gap-0 sm:tw-flex-row">
          {plans.map((plan, index) => (
            <div
              className={`${
                index === plans.length - 1 ? "sm:tw-ml-[-20px] " : ""
              }tw-w-auto tw-flex tw-justify-center md:tw-w-full md:tw-flex-1`}
              key={plan.tier}
            >
              <GroupPlanCard benefits={plan.benefits} tier={plan.tier} />
            </div>
          ))}
        </div>
      </div>
      <TestimonialSection />
      <div
        className={cn(
          "groups-info-tile-container tw-px-[15px] tw-py-[30px] tw-justify-center",
          "tw-flex tw-flex-col md:tw-px-0 md:tw-py-10"
        )}
        ref={quoteContainerRef}
      >
        <RequestQuoteSection />
        <FaqSection />
        <div className="tw-flex tw-flex-col tw-items-center tw-mt-10 tw-z-10">
          <span className="title-5 tw-text-teal tw-text-center tw-mb-3">
            Ready to save with a group subscription?
          </span>
          <RequestQuoteButton scrollToQuote={scrollToQuote} />
        </div>
      </div>
    </div>
  );
};

export default GroupInfoPage;
